module.exports = __webpack_public_path__ + "static/media/dimensions.a8c64f04.gif";